/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'

const entity = {
  name: {
    displayName: 'name'
  },
  lang: {},
  desc: {
    displayName: 'description',
    formConfig: {
      textArea: true,
      maxLength: 100,
      required: false,
      type: { name: 'description' }
    }
  }
}
export default IKDataEntity.ModelFactory(entity, {})
